import axios from 'lib/axios';

async function getAllServices(limit = 10, page = 1, query = '', dId) {
  const { data } = await axios.get(
    `/customer/service?limit=${limit}&page=${page}&query=${query}&divisionId=${dId || ''}`
  );
  return data;
}

const getServiceById = async (id) => {
  const { data } = await axios.get(`/customer/service/${id}`);
  return data;
};

export { getAllServices, getServiceById };
